export default {"src":"/_next/static/media/InsuranceGroup-1_vertical.b82f8aaa.svg","height":534,"width":82};